import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/inter';
import './index.css';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/pmis';
import { applyTheme } from './lib/theme';
import { HiddenUrlRouter } from './lib/router';
import { loadBranding } from './lib/branding';

applyTheme();
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 } } });

// Marca e formatos (Administração › Geral) antes da primeira tela: as datas já aparecem no formato escolhido.
void loadBranding().then(() => createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <HiddenUrlRouter>
            <App />
          </HiddenUrlRouter>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
));
